import { ArrowLeftOutlined, ArrowRightOutlined } from '@icon';
import { default as RCPagination, PaginationProps } from 'rc-pagination';
import 'rc-pagination/assets/index.css';
import React from 'react';
import { useTheme } from 'styled-components';
import { Select } from '../inputs';
import Typography from '../typography';
import { PaginationSC } from './pagination.styled';

interface ITablePagination extends Omit<PaginationProps, 'prevIcon' | 'nextIcon' | 'showTotal'> {
  showTotal?: boolean;
}

const Pagination: React.FC<ITablePagination> = ({
  showTotal,
  showSizeChanger,
  pageSizeOptions,
  pageSize,
  onShowSizeChange,
  onChange,
  style,
  ...rest
}) => {
  const theme = useTheme();

  return (
    <PaginationSC style={style}>
      <RCPagination
        {...rest}
        prevIcon={<ArrowLeftOutlined width={20} height={20} />}
        nextIcon={<ArrowRightOutlined width={20} height={20} />}
        showTotal={
          showTotal
            ? (total, range) => (
                <Typography
                  display="body2"
                  as={'span'}
                  style={{ color: theme.color.tint.tertiary }}
                >{`${range[0]}-${range[1]} / ${total}`}</Typography>
              )
            : undefined
        }
        pageSize={pageSize}
        onChange={onChange}
        onShowSizeChange={onShowSizeChange}
      />
      {showSizeChanger ? (
        <Select
          outlined
          options={
            pageSizeOptions ? pageSizeOptions.map((size) => ({ label: size, value: size })) : []
          }
          value={pageSize ? { value: pageSize, label: pageSize } : undefined}
          onChange={(v) => {
            if (!v) {
              return;
            }

            onChange?.(rest.current ?? 1, Number(v.value));
            onShowSizeChange?.(rest.current ?? 1, Number(v.value));
          }}
        />
      ) : null}
    </PaginationSC>
  );
};

export default Pagination;
